import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { useMatch } from "react-router-dom";
import {
  REVIEWS_ICON,
  REVIEWS_ICON_FILLED,
} from "../../../../redo-suite/marketing-cloud";
import { ReviewsToReviewContext } from "../../../../services/marketing/reviews-to-review-service";

export const ReviewsItems = memo(function ReviewsItems() {
  const team = useRequiredContext(TeamContext);
  const routes = useRequiredContext(MerchantRoutesContext);

  const reviewCount = useContext(ReviewsToReviewContext);

  const reviewsEnabled = team?.settings.reviews?.enabled;

  const reviewsBaseUrl = routes.marketingBaseUrl + "/reviews";
  const anyChildSelected = useMatch(`${reviewsBaseUrl}/*`);

  if (!reviewsEnabled) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("dashboard") }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={REVIEWS_ICON_FILLED}
      friendlyName="Reviews"
      id="reviews"
      notificationCount={reviewCount}
      UnfilledIcon={REVIEWS_ICON}
    >
      <ReviewsDashboardItem />
      <ReviewsAllReviewsItem />
      <ReviewsDisplaysWidgetsItem />
      <ReviewsProductsItem />
      <ReviewsResponseItem />
      <ReviewsSettingsItem />
    </RedoSecondaryNavItem>
  );
});

const ReviewsDashboardItem = memo(function ReviewsDashboardItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("dashboard") }}
      friendlyName="Dashboard"
      id="reviews-dashboard"
    />
  );
});

const ReviewsAllReviewsItem = memo(function ReviewsAllReviewsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("all-reviews") }}
      friendlyName="All reviews"
      id="reviews-all-reviews"
    />
  );
});

const ReviewsDisplaysWidgetsItem = memo(function ReviewsDisplaysWidgetsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getReviewsSubRoute("reviews-displays-widgets"),
      }}
      friendlyName="Displays & Widgets"
      id="reviews-displays-widgets"
    />
  );
});

const ReviewsProductsItem = memo(function ReviewsProductsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("products") }}
      friendlyName="Products"
      id="reviews-products"
    />
  );
});

const ReviewsResponseItem = memo(function ReviewsResponseItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getReviewsSubRoute("reviews-response"),
      }}
      friendlyName="Response"
      id="reviews-response"
    />
  );
});

const ReviewsSettingsItem = memo(function ReviewsSettingsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("settings") }}
      friendlyName="Settings"
      id="reviews-settings"
    />
  );
});
